import { combineReducers } from "redux";
import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
// reducers:
import AssetDetails from "./asset/reducer";
import WalletReducer from "./wallet/reducer";

const rootReducer = combineReducers({
  wallet: WalletReducer,
  asset: AssetDetails,
})

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;

export type State = ReturnType<typeof rootReducer>
